import Vue from 'vue'
import Router from 'vue-router'
import store from './store'


const Higgs = () => import('./HIGGS.vue')

const HiggsBackHome = () => import('./HIGGSBackHome.vue')
const HIGGSAdminAccount = () => import('./HIGGSAdminAccount.vue')
const HIGGSAgentAccount = () => import('./HIGGSAgentAccount.vue')
const HIGGSAgentManagement = () => import('./HIGGSAgentManagement.vue')
const HIGGSProductManagement = () => import('./HIGGSProductManagement.vue')
const HIGGSProductPictureManagement = () => import('./HIGGSProductPictureManagement.vue')
const HIGGSMyOrder = () => import('./HIGGSMyOrder.vue')
const HiggsMessage = () => import('./HIGGSMessage.vue')

const HIGGSRegister = () => import('./HIGGSRegister.vue')
const HIGGSPay = () => import('./HIGGSPay.vue')
const HIGGSIntroduce = () => import('./HIGGSIntroduce.vue')

Vue.use(Router)
// 3.0以上版本重复点击菜单栏，报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
    //  重定向路由
    { path: '/', redirect: '/Higgs' },
    { path: '/Higgs', component: Higgs, meta:{requireAuth:true}},
    { path: '/HiggsRegister', component: HIGGSRegister, meta:{requireAuth:true}},
    { path: '/HiggsIntroduce', component: HIGGSIntroduce, meta:{requireAuth:true}},
    { path: '/HiggsPay', component: HIGGSPay },
    {
      path: '/HiggsBackHome',
      component: HiggsBackHome,
      children: [
        { path: '/HiggsAdminAccount', component: HIGGSAdminAccount },
        { path: '/HiggsAgentAccount', component: HIGGSAgentAccount },
        { path: '/HiggsAgentManagement', component: HIGGSAgentManagement },
        { path: '/HiggsProductManagement', component: HIGGSProductManagement },
        { path: '/HIGGSProductPictureManagement', component: HIGGSProductPictureManagement },
        { path: '/HIGGSMyOrder', component: HIGGSMyOrder },
        { path: '/HiggsMessage', component: HiggsMessage }, 
      ]
    },
  ]
})

// 挂载路由导航守卫 to将要访问的路径  from从哪个路径跳转而来  next函数，放行
router.beforeEach((to, from, next) => {
  const token = store.state.token ? store.state.token : window.sessionStorage.getItem("token");
  console.log("token="+token)
  const role = store.state.role ? store.state.role : window.sessionStorage.getItem("role");
  console.log("role="+role)
  const userCode = store.state.userCode ? store.state.userCode : window.sessionStorage.getItem("userCode");
  console.log("userCode="+userCode)
  const language = store.state.language ? store.state.language : window.sessionStorage.getItem("language");
  console.log("language="+language)

  // 路径判断
  if(to.path ==='/Higgs'){
    return next()
  }
  else if(to.path ==='/HiggsIntroduce'){
    return next()
  }
  else if(to.path ==='/HiggsRegister'){
    return next()
  }
  else {
    if(!token){
      return next('/Higgs')
    }else{
      next()
    }
  }
})

export default router
